export const Degree: { [key: string]: string } = {
  BEGONNEN: "Begonnen",
  GEFESTIGT: "Gefestigt",
  AUF_DEM_SPRUNG: "Auf dem Sprung",
};
